import React from 'react';

export const NotificacionesLoteConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth: ['rh', 'rh_not_signer'],
    routes: [
        {
            path: '/notificaciones-lote',
            component: React.lazy(() => import('./NotificacionesLote'))
        }
    ]
};
